import { Component, OnDestroy, OnInit, inject, DestroyRef } from "@angular/core";
import { CommonModule } from "@angular/common";
import { WorkspacesService } from "../main/accountant/workspaces.service";
import { DashboardModule } from "../dashboard.module";

import { LocalStorageService } from "src/app/utils/localstorage.service";

import { SharedDataService } from "../shared-data.service";
import { MessageBubbleService } from "../conversations/message-bubble/message-bubble.service";
import { DashboardService } from "../dashboard.service";
import { QuickbooksIntegrationService } from "../quickbooks-integration.service";
import { HotToastService } from "@ngneat/hot-toast";
import { XeroIntegrationService } from "../xero-integration.service";
import { ConversationsService } from "../conversations/conversations.service";

import { PinFilterComponent } from "../components/pin-filter/pin-filter.component";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { EasyUploadComponent } from "src/app/dashboard/main/panels/easy-upload/easy-upload.component";

@Component({
    selector: "ch-client-workspace",
    imports: [
        CommonModule,
        DashboardModule,
        PinFilterComponent,
        BsDropdownModule,
        EasyUploadComponent
    ],
    templateUrl: "./client-workspace.component.html",
    styleUrls: [
        "./client-workspace.component.css",
        "../main/accountant/workspaces.component.scss",
    ]
})
export class ClientWorkspaceComponent implements OnInit, OnDestroy {
  current_company = {
    users: [],
    accountants: [],
    company_conversation: <any>{},
    accounting_company: { color: "#fff" },
    apps: [],
    resources: [],
    show_reviews: Boolean,
    name: "",
    has_qbd: false,
    has_xero: false,
    loading: false,
  };

  data: any;
  pinnedCount = 0;
  pinnedMessagesActive = false;

  currentMessagesFilter = "all";

  tracked_view_type = "card";

  loadings = {
    tracked_items: false,
  };

  isHuddleAvailable = false;
  isPanelClientTasksHidden = false;
  isPanelConversationHidden = false;
  isPanelLinksHidden = false;

  readonly destroyRef = inject(DestroyRef);

  constructor(
    private workspacesService: WorkspacesService,
    private localStorageService: LocalStorageService,
    private sharedDataService: SharedDataService,
    private messageBubbleService: MessageBubbleService,
    private dashboardService: DashboardService,
    private quickbooksIntegrationService: QuickbooksIntegrationService,
    private xeroService: XeroIntegrationService,
    private toastr: HotToastService,
    private conversationsService: ConversationsService
  ) {}

  ngOnInit(): void {
    this.data = this.localStorageService.get("data");

    this.workspacesService.$company
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((company) => {
        this.current_company = company;
        this.getPinnedCount();
      });

    this.messageBubbleService.togglePin$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((sub) => {
        this.getPinnedCount();
      });

    this.dashboardService.isHuddleAvailable().then((res: any) => {
      console.log("isHuddleAvailable", res);
      this.isHuddleAvailable = res;
    });

    setTimeout(() => {
      this.getPinnedCount();
    }, 3000);
  }

  ngOnDestroy() {}

  togglePanel(panel: string): void {
    if (panel === "clientTasks") {
      this.isPanelClientTasksHidden = !this.isPanelClientTasksHidden;
    } else if (panel === "conversation") {
      this.isPanelConversationHidden = !this.isPanelConversationHidden;
    } else if (panel === "links") {
      this.isPanelLinksHidden = !this.isPanelLinksHidden;
    }
  }

  toggleSearchMode() {
    this.workspacesService.showSearch.next(null);
  }

  togglePinMode() {
    if (this.currentMessagesFilter != "pinned") {
      this.changeMessagesFilter("pinned");
      return;
    }

    if (this.currentMessagesFilter == "pinned") {
      this.changeMessagesFilter("all");
      return;
    }
  }

  changeMessagesFilter(filter: string) {
    this.currentMessagesFilter = filter;
    this.workspacesService.changeMessagesFilter.next(filter);
  }

  hasAnyReviewSet() {
    if (this.current_company.accounting_company == null) {
      return false;
    }

    const reviewLinks = [
      this.current_company.accounting_company["review_linkedin"],
      this.current_company.accounting_company["review_xero"],
      this.current_company.accounting_company["review_proadvisor"],
      this.current_company.accounting_company["review_google"],
    ];

    for (var index = 0; index < reviewLinks.length; index++) {
      if (reviewLinks[index]) {
        return true;
      }
    }
    return false;
  }

  getPinnedCount() {
    if (this.current_company?.company_conversation != null) {
      if (this.current_company["company_conversation"]["messages"] != null) {
        this.pinnedCount = this.current_company["company_conversation"][
          "messages"
        ].filter((m) => {
          return m.pinned == true || m.pinned == "pinned";
        }).length;
      }
    }
  }

  toggleBotMessages(show) {
    this.current_company["company_conversation"]["options"][
      "show_bot_messages"
    ] = !show;
    console.log(
      "value before toggle",
      this.current_company["company_conversation"]["options"]
    );
    this.dashboardService.show_loading.next(true);
    this.conversationsService
      .save_notification_settings(
        this.current_company["company_conversation"]["id"],
        this.current_company["company_conversation"].options
      )
      .then(
        (res: any) => {
          this.dashboardService.show_loading.next(false);
          console.log(
            "value after toggle",
            this.current_company["company_conversation"].options
          );
          this.workspacesService.refreshSystemBotStatus.next(
            this.current_company["company_conversation"].options
          );
        },
        (err) => {
          console.log(err);
          this.dashboardService.show_loading.next(false);
        }
      );
  }

  checkNewQBOTransactions() {
    this.dashboardService.show_loading.next(true);
    this.quickbooksIntegrationService
      .getPurchases(this.current_company["id"])
      .subscribe(
        (res) => {
          this.toastr.success(res.message);
          this.dashboardService.show_loading.next(false);
        },
        (err) => {
          this.dashboardService.show_loading.next(false);
          this.toastr.error(err.error.message);
        }
      );
  }

  checkNewXeroTransactions() {
    this.xeroService
      .refreshBankTransactions(this.current_company["id"])
      .subscribe((res) => {
        this.toastr.info("Searching for new transactions in Xero");
      });
  }

  syncQBOTransactions() {
    this.dashboardService.show_loading.next(true);
    this.quickbooksIntegrationService
      .syncPurchases(this.current_company["id"])
      .subscribe(
        (res) => {
          this.toastr.success(res.message);
          this.dashboardService.show_loading.next(false);
        },
        (err) => {
          this.dashboardService.show_loading.next(false);
          this.toastr.error(err.error.message);
        }
      );
  }
}
